module.exports = __webpack_public_path__ + "acff60ffd29105418a8fa7a215da6215.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/favicons/favicon_32x32.png
// module id = 313
// module chunks = 0